export class BreakpointsConstants {
  static readonly LARGE_SCREEN: number = 1280;
  static readonly MEDIUM_SCREEN: number = 900;
  static readonly MOBILE_SCREEN: number = 400;
}
